import React, { useEffect } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import tokenImg from "../@shared/assets/infift_token.png";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1400,
};

const modalStyle = {
  width: 280,
  padding: 24,
  backgroundColor: "#1e1149",
  borderRadius: 16,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const variants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: [1.1, 1],
    opacity: 1,
    transition: { times: [0, 1], duration: 0.3, ease: "easeOut" },
  },
  exit: { scale: 0, opacity: 0, transition: { duration: 0.2 } },
};

export default function PurchasedItemModal({ visible, item, onClose }) {
  return (
    <Modal open={visible} onClose={onClose} closeAfterTransition>
      <AnimatePresence>
        {visible && (
          <Box
            component={motion.div}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={variants}
            style={overlayStyle}
          >
            <Box style={modalStyle}>
              <Typography
                variant="h6"
                sx={{ color: "#fff", fontWeight: "bold", mb: 1 }}
              >
                You Received
              </Typography>
              <motion.img
                src={item?.product?.image}
                alt=""
                // animate={{
                //   scale: [1, 1.1, 1],
                // }}
                // transition={{
                //   duration: 0.6,
                //   repeat: Infinity,
                //   repeatType: "reverse",
                // }}
                style={{
                  width: "auto",
                  height: "40dvh",
                  margin: "12px 0",
                }}
              />
              <Typography
                sx={{ fontSize: 20, color: "#13ffaf", fontWeight: 600, mb: 2 }}
              >
                Infinity Tokens
              </Typography>
              <Button
                variant="contained"
                onClick={onClose}
                sx={{
                  bgcolor: "#fbcf57",
                  color: "#1e1149",
                  fontWeight: "bold",
                  px: 3,
                  py: 1,
                  borderRadius: 1,
                  "&:hover": { bgcolor: "#e0b44c" },
                }}
              >
                Continue
              </Button>
            </Box>
          </Box>
        )}
      </AnimatePresence>
    </Modal>
  );
}
